export const NameValue = ({ name, value }) => (
  <div className="property">
    <span className="field w-50">{name}</span> <span className="value w-50">{value}</span>
  </div>
);